// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./assets/styles/main.scss
 ** module id = 10
 ** module chunks = 1
 **/